import { getDateAddingDuration, getFormattedDate } from '@shared/helpers/datetime/datetime';
import { fakeData } from '../MyBooking/myBooking.fake';
import { FlightProduct, FlightType, ProductType } from '../MyBooking/myBooking.interfaces';
import { MyBookingFlightVerification } from './myBookingFlightVerification.interfaces';
import { DateFormat } from '@shared/interfaces/dates';
import { useNowUTC } from '@/helpers/useNow';

export function getFakeVerificationResponse(
    iteration: number
): MyBookingFlightVerification | null {
    const flights: FlightProduct[] = fakeData.products.filter(
        (x) => x.type === ProductType.Flight && x.ticket.type === FlightType.Ryanair
    ) as FlightProduct[];

    if (flights.length === 0) {
        return null;
    }

    const verification: MyBookingFlightVerification = {};

    flights.forEach((flight) => {
        if (!flight.ticket.pnr || !flight.ticket.verification) return;

        const current = flight.ticket.verification;

        if (current?.confirmed) {
            verification[flight.ticket.pnr] = {
                url: current.url,
                confirmed: true,
                validUntil: current.validUntil,
            };
            return;
        }

        if (!current?.url && !current?.confirmed && iteration >= 2) {
            const { now } = useNowUTC();
            const nowDate = new Date(now.value);

            verification[flight.ticket.pnr] = {
                url: `https://ryanair.com/`,
                confirmed: false,
                validUntil: getFormattedDate(
                    getDateAddingDuration(nowDate, { minutes: 2 }),
                    DateFormat.ISO
                ),
            };
        } else {
            verification[flight.ticket.pnr] = {
                url: current?.url ?? null,
                confirmed: current?.confirmed ?? false,
                validUntil: current?.validUntil ?? null,
            };
        }
    });

    return Object.keys(verification).length > 0 ? verification : null;
}
